import { Component } from '@angular/core';
import { NavParams, PopoverController, ToastController, ViewController } from 'ionic-angular';
import { Comentarios } from '../../app/interfaces';
import { ComentarioDeComentarioPage } from '../../pages/comentario-de-comentario/comentario-de-comentario';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditarComentariosDeComentariossComponent } from '../editar-comentarios-de-comentarioss/editar-comentarios-de-comentarioss';

/**
 * Generated class for the PopoverComentariosDeComentariosComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'popover-comentarios-de-comentarios',
  templateUrl: 'popover-comentarios-de-comentarios.html'
})
export class PopoverComentariosDeComentariosComponent {

  comentarioPrincipal: Comentarios;
  comentario: Comentarios;

  constructor( public navParams: NavParams,
               public viewCtrl: ViewController,
               private restApi: RestApiProvider,
              //  private vista: ComentarioDeComentarioPage,
               public toastCtrl: ToastController,
               public popoverCtrl: PopoverController) 
  {
    this.comentarioPrincipal = this.navParams.get('comentarioPrincipal');
    if (!this.comentarioPrincipal) {
      return;
    }
    this.comentario = this.navParams.get('comentario');
    if (!this.comentario) {
      return;
    }
    
  }

  editarComentario(myEvent, comentario: Comentarios, 
    comentarioPrincipal: Comentarios) {
    let popover = this.popoverCtrl
    .create(EditarComentariosDeComentariossComponent, 
      {comentario, comentarioPrincipal}, { cssClass: 'custom-popover'});
    popover.present({
      // ev: myEvent
    });
  }

  borrarComentario(comentario) {
    this.restApi.borrarComentariodeComentario(comentario, 
      this.comentarioPrincipal)
    .subscribe((response: any) => { 
        const toast = this.toastCtrl.create({
          message: 'Comentario eliminado',
          duration: 2000
        });
        toast.present();
    });
    // this.vista.actualizarLista();
    this.cerrarpop();
  }

  cerrarpop() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/popover-comentarios-de-comentarios/popover-comentarios-de-comentarios.ts